import React from "react";
import { Redirect } from "react-router-dom";
import { useAuth } from "../hooks/useAuth"; // Reutilize seu hook de autenticação

export default function PublicRouteWhenAuthenticated({ children }) {
  const { isAuthenticated, loading } = useAuth(); // Inclua 'loading' do seu AuthContext

  // Se ainda estiver carregando, mostre um indicador ou apenas retorne null
  // para evitar redirecionamento prematuro
  if (loading) {
    return null; // Ou um <LoadingSpinner />
  }

  // Se o usuário já estiver autenticado, redirecione para o dashboard
  if (isAuthenticated) {
    return <Redirect to="/main/dashboard/analytics" />;
  }

  // Se não estiver autenticado, permita que a rota seja renderizada
  return children;
}
